var $ = require('jquery');

$(document).ready(function(){

// OVERLAY
  var btn = '.home__overlay__content__buttons--',
      canvas = $('.canvas');

  $('.js-button--home').hover(function(){
    $('.content').addClass('hide');
    var $btn_home = $(this);
  })

// Prevent scrolling while overlay is shown
  var $myDiv = $('.home__overlay'),
      body = $('body');
  if ( $myDiv.length){
    body.addClass('no-scroll');
    $('.button--home').click( function() {
      $('.overlay').fadeOut(400);
      setTimeout(function(){
          body.removeClass('no-scroll');
      }, 500)
      $('.content').css('opacity', 1);
    });
  }



});



// $(window).on('load', function() {

//     var resizeTimer; // Set resizeTimer to empty so it resets on page load

//     function resizeFunction() {

//       var
//       heightLeft = $('#machtigste-schere-der-welt-page').find('.height--1').height(),
//       widthLeft = $('#machtigste-schere-der-welt-page').find('.height--1').width() / 2.5;

//       $('.shape--1').css({
//         'height' : heightLeft,
//         'width' : widthLeft,
//         'clip-path' : 'polygon(0 0, 0 ' + heightLeft + 'px, ' + widthLeft + 'px ' + heightLeft / 2 + 'px)',
//         'shape-outside' : 'polygon(0 0, 0 ' + heightLeft + 'px, ' + widthLeft + 'px ' + heightLeft / 2 + 'px)'
//       });

//     };

//     // On resize, run the function and reset the timeout
//     // 250 is the delay in milliseconds. Change as you see fit.
//     $(window).resize(function() {
//         clearTimeout(resizeTimer);
//         resizeTimer = setTimeout(resizeFunction, 250);
//     });

//     resizeFunction();

// });



import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

//home


if (document.querySelector('.home__overlay')) {
  let homeOverlay = '.home__overlay'
  let homeTimeline = gsap.timeline();

  homeTimeline
    .to(".cover-left", 1, { scaleX: 0, transformOrigin: "left" })
    .to(".cover-right", 1, { scaleX: 0, transformOrigin: "right" }, "-=1")
    .from(".img-left", 1 {scale: 1.2}, "-=1")
    .from(".img-right", 1 {scale: 1.2}, "-=1")

    // .from(".home__relief path", {scale: 0, ease: "none", transformOrigin: "center", stagger: 0.02})
    // .from(".home__relief", {opacity: 0})
    .from(".title", 1.5, { y: -50 }, "-=1")
    .from(".title-number", 1.5, { y: 200 }, "-=1.5")
    .from(".img-left", 1 {x: -25})
    .from(".img-right", 1 {x: 25}, "-=1")
    .from(".home__overlay__content__buttons", 1 {y: 50, opacity: 0}, "-=1");

}

